'use strict';
var userServiceErrorCodes    = require('./lib/userService');
var authServiceErrorCodes    = require('./lib/authService');
var groupServiceErrorCodes   = require('./lib/groupService.js');
var ylandsApiErrorCodes      = require('./lib/ylandsApi.js');
var storageServiceErrorCodes = require('./lib/storageService.js');
var depotErrorCodes          = require('./lib/depot.js');
var spawnErrorCodes          = require('./lib/spawn.js');

/**
 * @type {Object}
 * @property {Object} userService
 */
module.exports.SPAWN           = spawnErrorCodes;
module.exports.DEPOT           = depotErrorCodes;
module.exports.USER_SERVICE    = userServiceErrorCodes;
module.exports.AUTH_SERVICE    = authServiceErrorCodes;
module.exports.GROUP_SERVICE   = groupServiceErrorCodes;
module.exports.YLANDS_API      = ylandsApiErrorCodes;
module.exports.STORAGE_SERVICE = storageServiceErrorCodes;
